import { z } from 'zod';
export const recipientResponseApiRoutes = {
    project: {
        path: '/response/:magicKey',
        method: 'GET',
        output: {},
    },
    submitTask: {
        path: '/response/:magicKey/task/:taskId',
        method: 'POST',
        input: z.object({
            response: z.any({}),
            saveForLater: z.boolean().default(true),
        }),
        output: z.string(),
    },
    declineTask: {
        path: '/response/:magicKey/task/:taskId/decline',
        method: 'POST',
        input: z.object({
            declineReason: z.string(),
        }),
        output: z.string(),
    },
    recipientViewedTask: {
        path: '/response/:magicKey/task/:taskId/viewed',
        method: 'POST',
        output: {},
    },
    recipientTaskView: {
        path: '/response/:magicKey/task/:taskId/view',
        method: 'POST',
        output: z.boolean(),
    },
    recipientProjectView: {
        path: '/response/:magicKey/view',
        method: 'POST',
        output: z.boolean(),
    },
    updateRecipient: {
        path: '/response/:magicKey/recipient-update',
        method: 'POST',
        input: z.object({
            timezone: z.string().optional(),
            projectOptOut: z.boolean().optional(),
            orgOptOut: z.boolean().optional(),
        }),
        output: {},
    },
    getOrgRecipientNotificationSettings: {
        method: 'GET',
        path: '/response/notification-control/:magicKey',
        output: {},
    },
    optBackIntoOrganization: {
        method: 'POST',
        path: '/response/notification-control/:magicKey/opt-back-in',
        output: {},
    },
};
//# sourceMappingURL=recipient-response-api-routes.js.map